import { Component, Input } from '@angular/core';

import { SdTitleComponent } from '../../title/title.component';

@Component({
  selector: 'sd-reinsurance-list',
  templateUrl: './reinsurance-list.component.html',
  standalone: true,
  imports: [SdTitleComponent]
})
export class SdReinsuranceListComponent {
  @Input()
  items: string[];

  @Input()
  title: string;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel: number;
}
